import React from 'react';
import { FilterDropdown } from './FilterDropdown';
import { dynamicTranslations } from '@shared/utils/dynamicTranslation';

interface TimeFilterDropdownProps {
  selectedTime: string[];
  onTimeChange: (time: string[]) => void;
  onApplyFilter: () => void;
  onClearFilter: () => void;
  isFilterApplied: boolean;
}

export const TimeFilterDropdown: React.FC<TimeFilterDropdownProps> = ({
  selectedTime,
  onTimeChange,
  onApplyFilter,
  onClearFilter,
  isFilterApplied,
}) => {
  const { t } = dynamicTranslations();

  const availableTimes = [
    t('history.visits.filters.past'),
    t('history.visits.filters.future'),
  ];

  return (
    <FilterDropdown
      label={t('history.visits.filters.time')}
      selectedItems={selectedTime}
      availableItems={availableTimes}
      onItemsChange={onTimeChange}
      onApplyFilter={onApplyFilter}
      onClearFilter={onClearFilter}
      isFilterApplied={isFilterApplied}
    />
  );
};
